<template>
  <div>
    <div class="home_head"></div>
    <!-- <img src="../assets/img/banner_02.jpg" alt="" class="ban"> -->
    <div class="home_body">
      <div class="home_body_text">
        文华财经的ICS智能投顾系统，立足于文华先进的云计算技术和量化交易技术，涵盖策略研发、策略管理、用户订阅、用户管理等多个模块，助力期货公司把量化投研成果转化为智能投顾服务，提供一个完整的技术解决方案。
      </div>
      <div style="min-height: 442px" class="home_body_middle">
        <div style="width: 1191px; margin: 0 auto; position: relative">
          <div class="cancli canleft" @click="goto(1)">
            <div class="lscale fd"></div>
            <img
              src="../assets/img/bg_1-zi.png"
              alt=""
              style="margin-top: 1px; z-index: 99; position: absolute; left: 0"
            />
            <div class="poleft">
              <img src="../assets/img/xiaofangz.png" alt="" />
              <p class="p1">管理端</p>
            </div>
          </div>
          <div class="climid">
            <img src="../assets/img/hmid.png" alt="" />
          </div>
          <div
            class="cancli canright"
            style="margin-left: 126px; margin-top: -1px"
            @click="goto(2)"
          >
            <div class="rscale fd"></div>
            <img
              src="../assets/img/bg_2-zi.png"
              alt=""
              style="margin-top: 3px; z-index: 99; position: absolute; left: 0"
            />
            <div class="poright">
              <img src="../assets/img/rne.png" alt="" class="psp" />
              <p class="p2" style="margin-top: 1px">用户使用端</p>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="home_body_lj">
        <div class="zg" @click="goto(1)">
          <img src="../assets/img/ziguan.png" alt="" />管理端
        </div>
        <div class="gw" @click="goto(2)">
          <img src="../assets/img/geren.png" alt="" />用户使用端
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    goto(id) {
      var newpage = this.$router.resolve({ path: `/feature?fe=${id}` });
      window.open(newpage.href, "_blank"); //单页面跳转路由锚点并打开新页面
    },
  },
};
</script>
<style scoped>
.home_head {
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=79) no-repeat center;
  height: 396px;
  /* width: 1920px;
  margin: 0 auto; */
}
.ban {
}
.home_body {
  height: 603px;
  background: url(../assets/img/bg.jpg) no-repeat center;
}
.home_body_text {
  width: 935px;
  padding-top: 55px;
  margin: 0 auto;
  color: #656565;
  font-size: 16px;
  text-align: left;
  text-indent: 2em;
  line-height: 28px;
}
.home_body_lj {
  padding-top: 18px;
  width: 1215px;
  margin: 0 auto;
}
.zg {
  width: 582px;
  height: 117px;
  background: url(../assets/img/l-xb.png) no-repeat center;
  margin-right: 40px;
  float: left;
  line-height: 119px;
  color: #f6f0f4;
  font-size: 20px;
  letter-spacing: 2px;
  cursor: pointer;
}
.gw {
  width: 582px;
  height: 117px;
  background: url(../assets/img/r-xb.png) no-repeat center;
  float: left;
  line-height: 119px;
  color: #f6f0f4;
  font-size: 20px;
  letter-spacing: 2px;
  cursor: pointer;
}
.zg img,
.gw img {
  margin-right: 10px;
  vertical-align: middle;
}
.zg:hover,
.gw:hover {
  opacity: 0.8;
}
.home_body_middle {
  /* background: url(../assets/img/alun.png) no-repeat center; */
  margin: 69px 0 15px 0;
  position: relative;
}
.home_body_middle .cancli {
  float: left;
  cursor: pointer;
  position: relative;
  width: 525px;
  height: 370px;
}
.lscale {
  width: 100%;
  height: 100%;
  background: url(../assets/img/hleft.png) no-repeat center;
}
.rscale {
  width: 100%;
  height: 100%;
  background: url(../assets/img/hleft.png) no-repeat center;
  transform: rotateY(180deg);
  -ms-transform: rotateY(180deg); /* IE 9 */
  -moz-transform: rotateY(180deg); /* Firefox */
  -webkit-transform: rotateY(180deg); /* Safari 和 Chrome */
  -o-transform: rotateY(180deg);
}
.home_body_middle .cancli .fd {
  position: absolute;
  -webkit-transition: -webkit-transform 0.3s;
  -moz-transition: -moz-transform 0.3s;
  -o-transition: -o-transform 0.3s;
  transition: transform 0.3s;
}
.home_body_middle .cancli:hover .lscale {
  -webkit-transform: scale(1.02);
  -moz-transform: scale(1.02);
  -ms-transform: scale(1.02);
  -o-transform: scale(1.02);
  transform: scale(1.02);
}
.home_body_middle .cancli:hover .rscale {
  -webkit-transform: scale(1.02) rotateY(180deg);
  -moz-transform: scale(1.02) rotateY(180deg);
  -ms-transform: scale(1.02) rotateY(180deg);
  -o-transform: scale(1.02) rotateY(180deg);
  transform: scale(1.02) rotateY(180deg);
}
.climid {
  position: absolute;
  left: 417px;
  top: -61px;
  z-index: 999;
  pointer-events: none;
}
.poleft {
  position: absolute;
  left: 39px;
  top: 18px;
  white-space: nowrap;
}
.poright {
  position: absolute;
  right: 27px;
  top: 14px;
  white-space: nowrap;
}
.poleft img {
  width: 24px;
}
.home_body_middle .cancli p {
  font-size: 21px;

  display: inline-block;
  line-height: 37px;
  vertical-align: top;
  margin-top: -5px;
  margin-left: 6px;
  color: #195da2;
}
.psp {
  margin-top: 6px;
}
</style>